<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Pago de Prestamo - Nuevo</strong>
          </CCardHeader>
          <CCardBody>
            <b-form id="Form" @submit.prevent="Validate">
              <b-row>
              

                <b-col md="6">
                  <b-form-group>
                    <label>Socio:</label>
                    <v-select @input="LoanDetailPayment" placeholder="Seleccione un socio" class="w-100" :filterable="false" label="full_name" v-model="partner" @search="SearchClients" :options="partners"></v-select>
                    <small v-if="errors.id_partner" class="form-text text-danger" >Seleccione un socio</small>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Nro Pago:">
                    <b-form-input class="text-center" readonly type="text" v-model="loan_payment.code"></b-form-input>
                    <small v-if="errors.code"  class="form-text text-danger" >Ingrese un numero</small>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Fecha de Pago:">
                    <b-form-input type="date" disabled class="text-center" v-model="loan_payment.payment_date"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Medio de Pago:">
                    <b-form-select :options="payment_method" v-model="loan_payment.payment_method"></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col md="8">
                  <b-form-group label="Observación:">
                    <b-form-textarea type="text" v-model="loan_payment.observation"></b-form-textarea>
                  </b-form-group>
                </b-col>


                <b-col md="4">
                  <b-form-group label="Anexos:">
                     <b-form-file
                      accept="application/pdf"
                      v-model="file"
                      :state="Boolean(file)"
                      @change="onFileChange"
                      placeholder="Selecciona un archivo"
                      drop-placeholder="Arrastre el archivo aqui"
                    ></b-form-file>
                  </b-form-group>
                </b-col>

                 <div class="col-md-12">
                  <div class="table-responsive mt-3">
                        <table  class="table  table-bordered table-hover table-lg mt-lg mb-0">
                          <thead>
                            <tr>
                              
                              <th width="7%" class="text-center">Prestamo</th>
                              <th width="5%" class="text-center">Cuota</th>
                              <th width="8%" class="text-center">F. Venc.</th>
                              <th width="5%" class="text-center">Amort.</th>
                              <th width="5%" class="text-center">Int.</th>
                              <th width="5%" class="text-center">Int. Dif.</th>
                              <th width="5%" class="text-center">Seg. Desg.</th>
                              <th width="5%" class="text-center">Seg. Mul.</th>
                              <th width="8%" class="text-center">S. Capital</th>
                              <th width="8%" class="text-center">Cuota</th>
                              <th width="7%" class="text-center">Dias Mor.</th>
                              <th width="7%" class="text-center">Moro.</th>
                              <th width="9%" class="text-center">Desc.</th>
                              <th width="7%" class="text-center">Cuota Final</th>
                              <th width="5%" class="text-center">Acc.</th>

                        
                            </tr>
                          </thead>
                          <tbody v-for="(item, it) in loan_payment_detail" :key="it">
                            <tr>
                                
                                <td class="align-middle text-center">{{ item.number }}</td>
                                <td class="align-middle text-center">{{ item.installment_number }}</td>
                                <td class="align-middle text-center">{{ item.expiration_date }}</td>
                                <td class="align-middle text-right">{{ item.amortization }}</td>
                                <td class="align-middle text-right">{{ item.interest }}</td>
                                <td class="align-middle text-right">{{ item.deferred_interest }}</td>
                                <td class="align-middle text-right">{{ item.insurance_lien }}</td>
                                <td class="align-middle text-right">{{ item.multi_insurance }}</td>
         
                                <td class="align-middle text-right">{{ item.principal_balance }}</td>
                                <td class="align-middle text-right">{{ item.fixed_fee }}</td>
                                <td class="align-middle text-center">{{ item.delinquent_days }}</td>
                                <td class="align-middle text-right">{{ item.delinquent_amount }}</td>
                                <td class="align-middle text-right">
                                  <b-form-input class="form-control text-right" @change="TotalPayment" type="number" step="any" v-model="item.discount"></b-form-input>
                                </td>
                                <td class="align-middle text-right">{{ item.total_fee }}</td>
                                <td class="align-middle text-center">
                                    <b-form-checkbox @change="TotalPayment"  size="sm" v-model="item.state" value="1" unchecked-value="0" ></b-form-checkbox>    
                                </td>
                            </tr>
                          </tbody>
                        </table>
                  </div>
            </div>

               
                
                <b-col md="12">
                  <br>
                </b-col>

                <b-col md="8">
                  <b-row>
                    
                  </b-row>
                </b-col>

                <b-col md="4">
                  <b-form-group  label-cols-sm="7" label="Subtotal :" class="text-right m-0">
                    <b-form-input class="text-right" disabled type="number" step="any" v-model="loan_payment.subtotal"></b-form-input>
                  </b-form-group>
                  <b-form-group  label-cols-sm="7" label="Morosidad :" class="text-right m-0">
                    <b-form-input class="text-right" disabled type="number" step="any" v-model="loan_payment.delinquent_amount"></b-form-input>
                  </b-form-group>
                  <b-form-group  label-cols-sm="7" label="Descuento :" class="text-right m-0">
                    <b-form-input class="text-right" disabled type="number" step="any" v-model="loan_payment.discount"></b-form-input>
                  </b-form-group>
                  <b-form-group  label-cols-sm="7" label="Total :" class="text-right m-0">
                    <b-form-input class="text-right" disabled type="number" step="any" v-model="loan_payment.total"></b-form-input>
                    <small v-if="errors.total"  class="form-text text-danger" >No cuenta con aportes</small>
                  </b-form-group>
                </b-col>

                <b-col md="5"></b-col>
                <b-col md="2">
                  <b-button type="submit" class="form-control" variant="primary" ><i class="fas fa-save"></i> Guardar (F4)</b-button>
                </b-col>
                
              </b-row>
            </b-form>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>


    <ModalClients />
    <LoadingComponent :is-visible="isLoading"/>
    <Keypress key-event="keyup" :key-code="115" @success="Validate" />
  </div>
</template>

<script>

import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";


const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
var moment = require("moment");

import { mapState,mapMutations,mapActions } from "vuex";
import EventBus from "@/assets/js/EventBus";
// components
import ModalClients from './../components/ModalClient'
import LoadingComponent from './../pages/Loading'
export default {
  name: "UsuarioAdd",
  components:{
      vSelect,
      ModalClients,
      Keypress: () => import('vue-keypress'),
      LoadingComponent,
  },
  data() {
    return {
      isLoading: false,
      module: 'LoanPayment',
      role: 2,
      loan_payment: {
          id_loan_payment:'',
          id_partner:'',
          id_user:'',
          code:'',
          payment_method:'008',
          payment_date:moment(new Date()).local().format("YYYY-MM-DD"),
          observation:'',
          file:'',
          subtotal:'0.00',
          delinquent_amount:'0.00',
          discount:'0.00',
          total:'0.00',
          state:1,
      },
      loan_payment_detail:[],
      partners: [],
      partner:null,
      file:null,
      payment_method: [
        {value :"008", text :'EFECTIVO'},
        {value :"007", text :'CHEQUE'},
        {value :"001", text :'DEPÓSITO EN CUENTA'},
        {value :"003", text :'TRANSFERENCIA DE FONDOS'},
      ],
      errors: {
        id_partner: false,
        payment_method: false,
        number: false,
        contributions_detail: false,
        file: false,
        total: false,
      },
      validate: false,
    };
  },
  mounted() {
    this.GetCorrelative();
  },
  methods: {
    LoanDetailPayment,
    GetCorrelative,
    AddLoanPayment,
    Validate,
    SearchClients,
    TotalPayment,
    DataPrint,
    Print,
    onFileChange,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    user: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user;
    },
  },
};

function onFileChange(e) {
  this.loan_payment.file = e.target.files[0];
}

function TotalPayment() {
  let subtotal = 0;
  let delinquent_amount = 0;
  let discount = 0;
  for (let index = 0; index < this.loan_payment_detail.length; index++) {
    const element = this.loan_payment_detail[index];
    element.discount = element.discount.length == 0 ? 0 : element.discount;
    if (parseFloat(element.discount) > parseFloat(element.delinquent_amount)) {
      element.discount = 0;
    }
    element.total_fee = parseFloat(element.fixed_fee) + parseFloat(element.delinquent_amount) - parseFloat(element.discount);

    element.discount = parseFloat(element.discount).toFixed(2);
    element.total_fee = parseFloat(element.total_fee).toFixed(2);
    

    if (element.state == 1) {
      subtotal += parseFloat(element.fixed_fee);
      delinquent_amount += parseFloat(element.delinquent_amount);
      discount += parseFloat(element.discount);
    }
  }

  this.loan_payment.subtotal = parseFloat(subtotal);
  this.loan_payment.delinquent_amount = parseFloat(delinquent_amount);
  this.loan_payment.discount = parseFloat(discount);
  this.loan_payment.total = this.loan_payment.subtotal + this.loan_payment.delinquent_amount - this.loan_payment.discount;


  this.loan_payment.subtotal = parseFloat(this.loan_payment.subtotal).toFixed(2);
  this.loan_payment.delinquent_amount = parseFloat(this.loan_payment.delinquent_amount).toFixed(2);
  this.loan_payment.discount = parseFloat(this.loan_payment.discount).toFixed(2);
  this.loan_payment.total = parseFloat(this.loan_payment.total).toFixed(2);

}

function LoanDetailPayment() {
  let me = this;
  if (this.partner != null) {
    let id_partner = this.partner.id;
    let url = me.url_base + "loan-payment/list-payment-pending/"+id_partner;
    axios({
      method: "GET",
      url: url,
      headers: { "Content-Type": "application/json", token: me.token, module: me.module,role: me.role, },
    })
    .then(function (response) {
      if (response.data.status == 200) {
      me.loan_payment_detail = response.data.result;
      me.TotalPayment();
    }else{
      me.loan_payment_detail = [];
      me.TotalPayment();
    }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      me.isLoading = true;
    });
  }else{
    me.loan_payment_detail = [];
  }
  
  
}

function GetCorrelative() {
  let me = this;
  let url = me.url_base + "get-correlative/LoanPayment";
  axios({
    method: "GET",
    url: url,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module,role: 2, },
  })
  .then(function (response) {
    if (response.data.status == 200) {
      me.loan_payment.code = response.data.result.number;
    }else{
      me.loan_payment.code = '';
    }
  })
  .catch((error) => {
    Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    me.isLoading = true;
  });
}

function SearchClients(search, loading) {
  
   let me = this;
    let url = this.url_base + "search-partner/" + search;
    if (search !== "") {
      loading(true);
      axios({
        method: "GET",
        url: url,
      }).then(function (response) {
            me.partners = response.data;
            loading(false);
      })
    }
}


function AddLoanPayment() {
  let me = this;
  let url = me.url_base + "loan-payment/add";
 let data = new FormData();
  data.append("id_partner", me.partner.id);
  data.append("id_user", me.user.id_user);
  data.append("code", me.loan_payment.code);
  data.append("payment_method", me.loan_payment.payment_method);
  data.append("payment_date", me.loan_payment.payment_date);
  data.append("observation", me.loan_payment.observation);
  data.append("file", me.loan_payment.file);
  data.append("subtotal", me.loan_payment.subtotal);
  data.append("delinquent_amount", me.loan_payment.delinquent_amount);
  data.append("discount", me.loan_payment.discount);
  data.append("total", me.loan_payment.total);
  data.append("state", me.loan_payment.state);
  data.append("loan_payment_detail", JSON.stringify(me.loan_payment_detail));
  
  me.isLoading = true;
  axios({
    method: "POST",
    url: url,
    data: data,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module,role: me.role },
  })
    .then(function (response) {
      if (response.data.status == 201) {

          me.loan_payment.code = '';
          me.loan_payment.observation = '';
          me.loan_payment.file = '';
          me.loan_payment.payment_method = '008';
          me.loan_payment.payment_date = '';
          me.loan_payment.subtotal = '0.00';
          me.loan_payment.delinquent_amount = '0.00';
          me.loan_payment.discount = '0.00';
          me.loan_payment.total = '0.00';
          me.loan_payment.state = 1;
          me.loan_payment_detail = [];
          me.partner = null;
          me.file = null;
          me.GetCorrelative();
          me.DataPrint(response.data.result.id_loan_payment);

          me.$router.push({
            name: "ContributionAdd",
          });

        Swal.fire({ icon: 'success', text: response.data.message, timer: 3000,})
      }else{
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
      me.isLoading = false;
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      me.isLoading = true;
    });
}

function Validate() {
  this.errors.id_partner = this.partner == null ? true : false;
  this.errors.payment_method = this.loan_payment.payment_method.length == 0 ? true : false;
  this.errors.code = this.loan_payment.code.length == 0 ? true : false;
  this.errors.loan_payment_detail = this.loan_payment_detail.length == 0 ? true : false;
  this.errors.total = parseFloat(this.loan_payment.total) == 0 ? true : false;

  if (this.errors.id_partner) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate_add = false; }
  if (this.errors.payment_method) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate_add = false; }
  if (this.errors.code) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate_add = false; }
  if (this.errors.loan_payment_detail) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate_add = false; }
  if (this.errors.total) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate_add = false; }

  let me = this;
  Swal.fire({
    title: "Esta seguro de registrar el pago del prestamo?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.AddLoanPayment();
    }
  });
}



function DataPrint(id_loan_payment) {
  let me = this;
  let url = me.url_base + "loan-payment/data-print/"+id_loan_payment;
  axios({
    method: "GET",
    url: url,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module,role: me.role },
  })
  .then(function (response) {
    if (response.data.status == 200) {
      me.Print(response.data.result)
    }
  })
  .catch((error) => {
    Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    me.isLoading = true;
  });
}


function Print(info) {
  let url = 'http://localhost/print/consumirapi.php';
  var data = new FormData(); 
  data.append("info",JSON.stringify(info)); 

  axios({
    method: "POST",
    url: url,
    data:data,
    headers: {
      "Content-Type": "application/json",
      "Accept":"*/*",
    },
  })
    .then(function (response) {
     
    })
    .catch((error) => {
      console.log(error);
    });
}
</script>
